import {
    AfterContentInit,
    Component,
    DoCheck,
    EventEmitter,
    Input,
    IterableDiffers, KeyValueDiffer, KeyValueDiffers,
    OnChanges,
    Output,
    SimpleChanges,
    ChangeDetectorRef,
} from "@angular/core";
import * as _ from "lodash";
import {ToastrService} from "ngx-toastr";
import {Bot} from "../../../../../../../models/bot";
import {DataMapping} from "../../../../../../../models/data-mapping";
import {DataMappingHelpers} from "../../../../../../../models/data-mapping-helpers";
import {FieldGroup} from "../../../../../../../models/field-group";
import { BaseError } from "../../../../../base-error";

@Component({
    selector: "tree-branch",
    templateUrl: "./tree-branch.component.html",
})
export class TreeBranchComponent extends BaseError implements DoCheck, AfterContentInit, OnChanges {
    @Input() public branches: FieldGroup[] = [];
    @Input() public filter: any;
    @Input() public selectedTab: any = null;
    @Input() public lines: any[] = [];
    @Input() public type: string;
    @Input() public leftPrefix: string = "";
    @Input() public rightPrefix: string = "";
    @Input() public boardId: string;
    @Input() public isLtr: boolean;
    @Input() public dragSrc: any = {el: null };
    @Input() public isDragging: any = { value: false };
    @Input() public bot: Bot;
    @Input() public showAllFields: boolean = false;
    @Input() public checkingVisibility: any = { value: false };
    @Output("handleScroll") public handleScroll: EventEmitter<any> = new EventEmitter();
    @Output("updateRelationshipsPositions") public updateRelationshipsPositions: EventEmitter<any> = new EventEmitter();
    @Output("addRelationship") public addRelationship: EventEmitter<any> = new EventEmitter();
    @Output("removeSelection") public removeSelection: EventEmitter<any> = new EventEmitter();
    @Output("setSelectedMuleService") public setSelectedMuleService: EventEmitter<any> = new EventEmitter();
    @Output("addDataTransformation") public addDataTransformation: EventEmitter<any> = new EventEmitter();
    @Output("saveLines") public saveLines: EventEmitter<any> = new EventEmitter();
    @Output("removeRelationship") public removeRelationship: EventEmitter<any> = new EventEmitter();

    public meta: any[] = [];

    public linesDiffer: any = {};
    public oldDragSrcEl: any;

    public branchesDiffer: Array<KeyValueDiffer<string, any>>;

    public disabledFields: Array<{ type: string, isLtr: boolean }> = [
        { type: "htmlelement", isLtr: false },
    ];

    constructor(private iterableDiffers: IterableDiffers, public toastr: ToastrService, private differs: KeyValueDiffers, private changeDetectorRef: ChangeDetectorRef) {
        super(toastr);
        this.linesDiffer = iterableDiffers.find(this.lines).create(null);
        this.branchesDiffer = new Array<KeyValueDiffer<string, FieldGroup>>();
    }

    public ngAfterContentInit() {
        this.branches.forEach((branch, index) => {
            this.branchesDiffer[index] = this.differs.find(branch).create();
            // init static meta only once.
            this.initStaticMeta(branch, index);
            if (true || branch.name === "Applicant form" || branch.name === "Guide form" || branch.name === "Document form" || branch.name === "Send file page" || branch.name === "Payment page"
              || branch.name === "Constants" || branch.name === "Roles") {
                this.changeDetectorRef.detectChanges();
                // this.openAll(branch);
            }
        });
    }

    public ngDoCheck() {
        // check if any new lines present or existing ones deleted
        const changes = this.linesDiffer.diff(this.lines);
        if (changes) {
            this.changeMetaAfterLinesChange();
        }

        // check if dragSrc is changed
        if (!_.isEqual(this.oldDragSrcEl, this.dragSrc.el)) {
            this.branches.forEach((branch, index) => this.changeMetaAfterDragSrcChange(branch, index));
            this.oldDragSrcEl = this.dragSrc.el;
        }

        if (this.branchesDiffer.length > 0) {
            this.branches.forEach((branch, index) => {
                const objDiffer = this.branchesDiffer[index];
                const objChanges = objDiffer.diff(branch);
                if (objChanges) {
                    this.changeMetaAfterBranchChange(branch, index);
                }
            });
        }
    }

    public openAll(branch): void {
        if (branch.isgroup) {
            this.toggleBranch(branch);
            if (branch.items && branch.items.length) {
                branch.items.forEach((b) => {
                    this.openAll(b);
                });
            }
        }
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.branches && changes.branches.previousValue && changes.branches.previousValue.length) {
            this.branches.forEach((branch, index) => {
                this.branchesDiffer[index] = this.differs.find(branch).create();
                // init static meta only once.
                this.initStaticMeta(branch, index);
                if (branch.name === "Applicant form" || branch.name === "Guide form" || branch.name === "Document form" || branch.name === "Send file page" || branch.name === "Payment page"
                  || branch.name === "Constants" || branch.name === "Roles") {
                    this.changeDetectorRef.detectChanges();
                    // this.openAll(branch);
                }
            });
        }
        if (changes.showAllFields) {
            this.branches.forEach((branch, index) => {
                this.changeMetaAfterNgOnChange(branch, index, TreeBranchComponent.getGroupVisibility(branch, this.type));
            });
        }
    }

    public changeMetaAfterLinesChange() {
        this.branches.forEach((branch, index) => this.changeMetaAfterLineChange(branch, index));
    }

    public changeMetaAfterLineChange(branch, index) {
        // some meta data doesn't care about lines
        // console.log(branch);
        const hasGroupRelationship = TreeBranchComponent.haveGroupRelationship(branch, this.lines, this.type);
        const hasFieldRelationship = !branch.isgroup && TreeBranchComponent.haveFieldRelationship(branch.field, this.lines, this.type);
        const isSystemVariable = branch.field?.formTitle === "System variables";
        const isNotAvailable = branch.field && branch.isgroup && this.isUnAvailable(branch.field.type, this.isLtr) || (((branch.field?.remoteType === "catalog" && (!branch.catalog && !branch.dataSrc && !branch.catalogIds && !branch.parentCatalogField )) || (branch.field?.remoteType === "select" && !branch.catalogIds)) && branch.isgroup && branch.dataSrcCatalog !== "gdb" && !isSystemVariable);

        if (this.meta[index]) {
            if (!this.meta[index].rootClasses) { this.meta[index].rootClasses = {}; }
            if (!this.meta[index].ifs) { this.meta[index].ifs = {}; }
            this.meta[index].rootClasses["connected-child"] = hasGroupRelationship;
            this.meta[index].rootClasses.connected = hasFieldRelationship;
            this.meta[index].rootClasses.unavailable = isNotAvailable;
            this.meta[index].ifs.deleteIcon = this.type === "output" && hasFieldRelationship;
            this.meta[index].ifs.startIcon = (branch.isgroup && hasGroupRelationship && !branch.opened) || (this.type === "input" && hasFieldRelationship);
            if (this.type === "output" && hasFieldRelationship) {
                const lineRelationship = TreeBranchComponent.fieldRelationship(branch.field, this.lines, this.type);
                const linesRelationship = TreeBranchComponent.fieldRelationships(branch.field, this.lines, this.type);

                if (lineRelationship && linesRelationship?.length < 2) {
                    if (lineRelationship?.targetFieldProperties?.hasOwnProperty("sortByFields") && lineRelationship?.targetFieldProperties?.sortByFields.length) {
                        lineRelationship.targetFieldProperties.sortByFields = [];
                    }
                }
                this.meta[index].ifs.lines = linesRelationship;
                this.meta[index].ifs.line = lineRelationship;
                this.meta[index].readableTransformation = null;
                if (this.meta[index].ifs.line && this.meta[index].ifs.lines?.length < 2 && (this.meta[index].ifs.line.targetFieldProperties || (this.checkDeterminant(this.meta[index].ifs.line)))) {
                    this.meta[index].hasTransformation = true;
                    if (this.meta[index].ifs.line.targetFieldProperties?.hasOwnProperty("sortByFields") && this.meta[index].ifs.line.targetFieldProperties?.sortByFields.length) {
                        this.meta[index].readableTransformation = `${this.meta[index].readableTransformation ? this.meta[index].readableTransformation + "\n" : ""}${this.formatSortByField(this.meta[index].ifs.line.targetFieldProperties?.sortByFields)}`;
                    } else if (this.meta[index].ifs.line.targetFieldProperties?.hasOwnProperty("inputTransformations") && this.meta[index].ifs.line.targetFieldProperties?.inputTransformations.length) {
                        this.meta[index].readableTransformation = "Transform input\n";
                    } else {
                        this.meta[index].hasTransformation = this.meta[index].ifs.line.targetFieldProperties?.fieldOperator
                        || this.meta[index].ifs.line.targetFieldProperties?.useAsExactSearch
                        || this.meta[index].ifs.line.targetFieldProperties?.useAsFullTextSearch
                        || this.meta[index].ifs.line.targetFieldProperties?.useAsStartsWith
                        || (this.checkDeterminant(this.meta[index].ifs.line));
                        if (this.meta[index].ifs.line.targetFieldProperties?.useAsExactSearch) { this.meta[index].readableTransformation = `${this.meta[index].readableTransformation ? this.meta[index].readableTransformation + "\n" : ""}Exact match`; }
                        if (this.meta[index].ifs.line.targetFieldProperties?.useAsFullTextSearch) { this.meta[index].readableTransformation = `${this.meta[index].readableTransformation ? this.meta[index].readableTransformation + "\n" : ""}Contains`; }
                        if (this.meta[index].ifs.line.targetFieldProperties?.useAsStartsWith) { this.meta[index].readableTransformation = `${this.meta[index].readableTransformation ? this.meta[index].readableTransformation + "\n" : ""}Starts with`; }
                        if (this.meta[index].ifs.line.targetFieldProperties?.fieldOperator) { this.meta[index].readableTransformation = `${this.meta[index].readableTransformation ? this.meta[index].readableTransformation + "\n" : ""}${this.formatfieldOperatorLabel(this.meta[index].ifs.line.targetFieldProperties?.fieldOperator)}`; }
                        if (this.checkDeterminant(this.meta[index].ifs.line)) {
                            this.meta[index].readableTransformation = `${this.meta[index].readableTransformation ? this.meta[index].readableTransformation + "\n" : ""}Determinants`;
                        }
                    }
                } else {
                    if (this.meta[index].ifs.lines?.length > 1) {
                        this.meta[index].hasTransformation = false;
                        this.meta[index].ifs.lines.forEach((l) => {
                            if (this.checkLineTransformations(l)) {
                                this.meta[index].hasTransformation = true;
                            }
                        });
                    } else {
                        this.meta[index].hasTransformation = false;
                    }
                }
            }
            this.meta[index].transformationClasses = this.meta[index].hasTransformation ? "has-value" : "";
        } else {
            this.meta.push({
                rootClasses: {
                    "connected-child": hasGroupRelationship,
                    connected: hasFieldRelationship,
                    unavailable: isNotAvailable,
                },
                ifs: {
                    deleteIcon: this.type === "output" && hasFieldRelationship,
                    startIcon: (branch.isgroup && hasGroupRelationship && !branch.opened) || (this.type === "input" && hasFieldRelationship),
                },
            });
        }

    }

    public checkLineTransformations(line) {
        return this.checkTargetFieldProperties(line.targetFieldProperties) || this.checkDeterminant(line);
    }

    public checkTargetFieldProperties(targetFieldProperties) {
        return targetFieldProperties?.distinctByFields?.length ||
            targetFieldProperties?.groupByFields?.length ||
            targetFieldProperties?.inputTransformations?.length ||
            targetFieldProperties?.useAsExactSearch ||
            targetFieldProperties?.useAsFullTextSearch ||
            targetFieldProperties?.useAsStartsWith ||
            (targetFieldProperties?.fieldOperator?.length && targetFieldProperties?.fieldOperator !== "exact");
    }

    private checkDeterminant(field) {
        if (field.jsonDeterminant && JSON.stringify(field.jsonDeterminant) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            return true;
        }
        if (field.jsonDeterminant?.jsonString && JSON.stringify(field.jsonDeterminant.jsonString) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            return true;
        }
        if (field.jsonDeterminantFilter && JSON.stringify(field.jsonDeterminantFilter) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            return true;
        }
        if (field.jsonDeterminantFilter?.jsonString && JSON.stringify(field.jsonDeterminantFilter?.jsonString) !== "[{\"type\":\"OR\",\"items\":[]}]") {
            return true;
        }
    }

    public formatfieldOperatorLabel(value) {
        let label = "";
        switch (value) {
            case "exact":
                label = "Equals value";
                break;
            case "iexact":
                label = "Equals value without case-sensitive";
                break;
            case "exact~":
                label = "Not equals value";
                break;
            case "iexact~":
                label = "Not Equals value without case-sensitive";
                break;
            case "contains":
                label = "Contains value";
                break;
            case "nexact":
              label = "Equals normalized value";
              break;
            case "niexact":
              label = "Equals normalized value without case-sensitive";
              break;
            case "nexact~":
              label = "Not equals normalized value";
              break;
            case "niexact~":
              label = "Not Equals normalized value without case-sensitive";
              break;
            case "icontains":
                label = "Contains value without case-sensitive";
                break;
            case "in":
                label = "Can be found in";
                break;
            case "defers":
                label = "Not contains value";
                break;
            case "idefers":
                label = "Not contains value without case-sensitive";
                break;
            case "regex":
                label = "Regex expression";
                break;
            case "iregex":
                label = "Regex expression without case-sensitive";
                break;
            case "isnull":
                label = "Nullable";
                break;
            case "isnull~":
                label = "Not nullable";
                break;
            case "lt":
                label = "less than value";
                break;
            case "lte":
                label = "less or equal than value";
                break;
            case "gt":
                label = "greater than value";
                break;
            case "gte":
                label = "greater or equal than value";
                break;
            case "startswith":
                label = "Starts with";
                break;
            case "similarity":
                label = "Similarity";
                break;
            case "nsimilarity":
                label = "Similarity and normalization";
                break;
            case "fuzzy":
                label = "Fuzzy";
                break;
            case "fuzzy_1":
                label = "Fuzzy with precision class 1";
                break;
            case "fuzzy_2":
                label = "Fuzzy with precision class 2";
                break;
            case "fuzzy_3":
                label = "Fuzzy with precision class 3";
                break;
            case "fuzzy_4":
                label = "Fuzzy with precision class 4";
                break;
            case "fuzzy_5":
                label = "Fuzzy with precision class 5";
                break;
            case "fuzzy_6":
                label = "Fuzzy with precision class 6";
                break;
            case "fuzzy_7":
                label = "Fuzzy with precision class 7";
                break;
            case "fuzzy_8":
                label = "Fuzzy with precision class 8";
                break;
        }
        return label;
    }

    private formatSortByField(props) {
        let str = "";
        props.forEach((i) => {
            const existline = this.lines.filter((line) => line.field.fieldKey === i.id);
            let lbl = "";
            if (existline && existline[0] && existline[0].field) {
                 lbl = existline[0].field.label;
            }
            if (i.transformation === "uppercase") { lbl = lbl.toUpperCase(); }
            if (i.transformation === "lowercase") { lbl = lbl.toLowerCase(); }
            str += " " + i.separator + " " + lbl + " ";
        });
        return str;
    }

    public changeMetaAfterNgOnChange(branch, index, groupVisibility) {
        if (this.meta[index]) {
            if (!this.meta[index].rootClasses) { this.meta[index].rootClasses = {}; }
            this.meta[index].rootClasses.hidden = (branch.filter && branch.filter !== this.type) || (branch.fieldName === null && (!branch.items || branch.items.length === 0)) || (!this.showAllFields && !groupVisibility);
        } else {
            this.meta.push({
                rootClasses: {
                    hidden:  (branch.filter && branch.filter !== this.type) || (branch.fieldName === null && (!branch.items || branch.items.length === 0)) || (!this.showAllFields && !groupVisibility),
                },
            });
        }
    }

    public changeMetaAfterDragSrcChange(branch, index) {
        if (this.meta[index]) {
            if (!this.meta[index].rootClasses) { this.meta[index].rootClasses = {}; }
            this.meta[index].rootClasses["selected-to-connect"] = _.isEqual(branch.field, this.dragSrc.el);
        } else {
            this.meta.push({
                rootClasses: {
                    "selected-to-connect": _.isEqual(branch.field, this.dragSrc.el),
                },
            });
        }
    }

    public changeMetaAfterBranchChange(branch, index) {
        this.changeMetaAfterLineChange(branch, index); // all line changes are needed for branch change also
        const groupVisibility = TreeBranchComponent.getGroupVisibility(branch, this.type);
        this.changeMetaAfterNgOnChange(branch, index, groupVisibility);

        if (this.meta[index]) {
            if (!this.meta[index].rootClasses) { this.meta[index].rootClasses = {}; }
            if (!this.meta[index].eyeClasses) { this.meta[index].eyeClasses = {}; }
            this.meta[index].rootClasses.opened = branch.opened;
            this.meta[index].eyeClasses["fa-eye"] = groupVisibility;
            this.meta[index].eyeClasses["fa-eye-slash"] = !groupVisibility;
        } else {
            this.meta.push({
                rootClasses: {
                    opened: branch.opened,
                },
                eyeClasses: {
                    "fa-eye": groupVisibility,
                    "fa-eye-slash": !groupVisibility,
                },
            });
        }
    }

    public getDisplayName(branch) {
        console.log(branch);
        return branch.workingLabel || branch.anme;
    }

    private stripHtml(value: string): string {
        if (!value) { return value; }
        return value.replace(/<[^>]*>/g, "");
    }

    public initStaticMeta(branch, index) {
        const domId = DataMappingHelpers.getSanitizeID((branch.isgroup) ? branch.name : (branch.field ? branch.field.fieldKey : branch.name), this.leftPrefix);
        const isSystemVariable = branch.field?.formTitle === "System variables";
        const noCatalogSource = (((branch.field?.remoteType === "catalog" && (!branch.catalog && !branch.dataSrc && !branch.catalogIds && !branch.parentCatalogField )) || (branch.field?.remoteType === "select" && !branch.catalogIds)) && branch.isgroup && branch.dataSrcCatalog !== "gdb" && !isSystemVariable);
        const name = this.stripHtml(branch.name);
        const label = this.stripHtml(branch.label);
        const workingLabel = this.stripHtml(branch.workingLabel);
        if (this.meta[index]) {
            if (!this.meta[index].rootClasses) { this.meta[index].rootClasses = {}; }
            this.meta[index].rootClasses["fix-eye"] = this.type === "output";
            this.meta[index].rootClasses.branch = branch.isgroup;
            this.meta[index].rootClasses.leaf = !branch.isgroup;
            this.meta[index].rootClasses.unavailable = noCatalogSource;
            this.meta[index].noCatalog = noCatalogSource;
            this.meta[index].id = domId;
            this.meta[index].displayName = workingLabel ? `<span class="working-text">${workingLabel}<span class="working-text-tooltip">${name || label}</span></span>` : (name || label || branch.outpuName);
        } else {
            this.meta.push({
                rootClasses: {
                    "fix-eye": this.type === "output",
                    branch: branch.isgroup,
                    leaf: !branch.isgroup,
                },
                id: domId,
                displayName: workingLabel ? `<span class="working-text">${workingLabel}<span class="working-text-tooltip">${name || label}</span></span>` : (name || label || branch.outpuName),
            });
        }
    }

    public toggleBranch(branch: FieldGroup) {
        branch.opened = !branch.opened;
        if (!branch.opened && branch.items && branch.items.length > 0) { this.closeChildren(branch.items); }
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public closeChildren(items): void {
        if (items) {
            items.forEach((item) => {
                item.opened = false;
                if (item.hasOwnProperty("items")) {
                    this.closeChildren(item.items);
                }
            });
        }
    }

    public static haveFieldRelationship(field, lines: any[], type: string): boolean {
        return lines.some((line) => {
            if (!line.field) { return false; }
            if (!line.field.fieldKey) { return false; }
            return line.field.fieldKey === field.fieldKey && line.type === type;
        });
    }

    public static fieldRelationship(field, lines: any[], type: string): any {
        return lines.find((line) => {
            return line.field.fieldKey === field.fieldKey && line.type === type;
        });
    }

    public static fieldRelationships(field, lines: any[], type: string): any {
        return lines.filter((line) => {
            return line.field.fieldKey === field.fieldKey && line.type === type;
        });
    }

    public static haveGroupRelationship(groupRel, lines: any[], type: string): boolean {
        if (groupRel.items && Array.isArray(groupRel.items)) {
            return groupRel.items.some((item) => {
                if (!item.isgroup) {
                    return TreeBranchComponent.haveFieldRelationship(item.field, lines, type);
                } else {
                    return TreeBranchComponent.haveGroupRelationship(item, lines, type);
                }
            });
        }
        return false;
    }

    public isUnAvailable(type, isLTR) {
      if (!type) { return false; }
      return this.disabledFields.some((a) => {
        return a.type && (a.type.toLocaleLowerCase() === type.toLocaleLowerCase()) && a.isLtr === isLTR;
      });
    }

    public setFieldVisibility(field, status) {
        if (this.type === "input") {
            field.inputHidden = status;
        } else {
            field.outputHidden = status;
        }
    }

    public setGroupVisibility(branch): void {
        const status = TreeBranchComponent.getGroupVisibility(branch, this.type);
        if (!branch.isgroup) {
            this.setFieldVisibility(branch.field, status);
            branch.triggerChangeDetection = !branch.triggerChangeDetection;
        } else {
            if (branch.items && Array.isArray(branch.items)) {
                branch.items.forEach((item) => {
                    this.setGroupVisibility(item);
                });
            }
        }
        // for lines updated
        if (!this.checkingVisibility.value) {
            this.checkingVisibility.value = true;
            this.handleScroll.emit();
        }
    }

    public static getGroupVisibility(branch, type): boolean {
        if (!branch.isgroup) {
            return type === "input" ? !branch.field.inputHidden : !branch.field.outputHidden;
        } else {
            if (branch.items && Array.isArray(branch.items)) {
                return branch.items.some((item) => {
                    return TreeBranchComponent.getGroupVisibility(item, type);
                });
            }
        }
        return false;
    }

    public treeNodeOnClick(node: any): void {
        // console.log(node);
        if (this.isLtr) { return this.handleStartPointSelection(node.field); }
        return this.handleEndPointSelection(node.field);
    }

    public handleStartPointSelection(field): void {
        if (_.isEqual(this.dragSrc.el, field)) { return this.removeSelection.emit(); }
        if (this.dragSrc.el !== null) { this.removeSelection.emit(); }
        this.isDragging.value = true;
        this.dragSrc.el = field;
        // console.log(this.dragSrc);
    }

    public handleEndPointSelection(field): void {
        // console.log(field, this.isDragging, this.dragSrc);
        if (!this.isDragging.value) { return; }
        if (_.isEqual(this.dragSrc.el, field)) { return; }
        const tempMapping = {
            fieldKey: field.fieldKey,
            fieldType: field.remoteType,
            inputId: this.dragSrc.el.id,
            targetType: this.dragSrc.el.type,
        };
        const tempLine = {
            type: "output",
            field,
            input: this.dragSrc.el,
            startPoint: DataMappingHelpers.getSanitizeID(this.dragSrc.el.id, this.rightPrefix),
            endPoint: DataMappingHelpers.getSanitizeID(field.fieldKey, this.leftPrefix),
            boardId: this.boardId,
        };
        this.addRelationship.emit({
            map: tempMapping,
            line: tempLine,
            isLtr: false,
        });
        this.removeSelection.emit();
    }

    public deleteOutputRelationship(id): void {
        this.bot.outputFieldsMapping = this.bot.outputFieldsMapping
            .filter((ofm) => ofm.id !== id);
        // console.log(id, this.bot.outputFieldsMapping);
        this.removeRelationshipField(id);
        this.removeRelationship.emit(id);
        // this.saveLines.emit({ output: true});
    }

    public removeRelationshipField(id): void {
        const linesToRemove = [];
        // console.log(id, this.lines);
        this.lines.forEach((line, i) => {
            if (line.lineId === id) {
                if (line.line !== null) {
                    line.line.remove();
                    line.line = null;
                }
                linesToRemove.push(i);
            }
        });
        linesToRemove.sort((a, b) => b - a).forEach((ltr) => {
            this.lines.splice(ltr, 1);
        });
    }

    public onAddDataTransformation(branch): void {
        branch.boardId = this.boardId;
        this.addDataTransformation.emit(branch);
    }
}
